import type { BuildingRecipe, BuildingVariant } from './building';

const recipe = (variant: BuildingVariant, wear: number, roofSag: number): BuildingRecipe => ({
  schema: 'hush.asset-recipe.v1',
  id: `hush.hideout_building.${variant}.v1`,
  generatorId: 'hush.hideout_building.v1',
  seed: 20067018,
  paletteId: 'coastal_salt',
  params: { variant, wear, roofSag },
});

/** One default recipe per building variant (each backs one catalog template). */
export const HIDEOUT_BUILDING_RECIPES: Readonly<Record<BuildingVariant, BuildingRecipe>> = {
  boathouse: recipe('boathouse', 0.55, 0.6),
  woodcutter_hut: recipe('woodcutter_hut', 0.4, 0),
  tollhouse: recipe('tollhouse', 0.3, 0),
  boat_shelter: recipe('boat_shelter', 0.5, 0),
};
